// src/pages/HelpCenter.jsx
import React from "react";
import { Link } from "react-router-dom";
import "./LegalPages.css";

export default function HelpCenter() {
  return (
    <div className="legal-page">
      <h1>Help Center</h1>
      <p className="legal-intro">
        Find answers, understand how NexterZone works, and learn how to report issues safely.
      </p>

      <div className="legal-grid">
        {/* HOW THE PLATFORM WORKS */}
        <section className="legal-card">
          <h2>How NexterZone works</h2>
          <p>
            NexterZone uses a platform-managed workflow instead of direct buyer–seller arrangements.
            This helps reduce scams, unsafe meetups, and stolen-goods activity.
          </p>
          <div className="legal-actions">
            <Link className="legal-btn primary" to="/help/how-trades-work">
              Trade workflow
            </Link>
            <Link className="legal-btn" to="/help/why-no-direct-chat">
              Why no direct chat
            </Link>
          </div>
        </section>

        {/* FAQ */}
        <section className="legal-card">
          <h2>Frequently Asked Questions</h2>
          <p>Common questions about offers, safety holds, verification, and account issues.</p>
          <div className="legal-actions">
            <Link className="legal-btn" to="/faq">Open FAQ</Link>
          </div>
        </section>

        {/* TRUST & SAFETY */}
        <section className="legal-card">
          <h2>Trust & Safety</h2>
          <p>
            How NexterZone prevents fraud and theft through risk screening,
            evidence checks, inspections, and controlled logistics.
          </p>
          <div className="legal-actions">
            <Link className="legal-btn" to="/trust-safety">Read Trust & Safety</Link>
          </div>
        </section>

        {/* SUPPORT */}
        <section className="legal-card">
          <h2>Contact Support</h2>
          <p>
            Send a message to NexterZone Support. We do not expose emails or phone numbers
            to other users.
          </p>
          <div className="legal-actions">
            <Link className="legal-btn primary" to="/support">Contact Support</Link>
          </div>
        </section>

        {/* REPORTING */}
        <section className="legal-card">
          <h2>Report an item</h2>
          <p>
            If you suspect fraud, stolen goods, or a misleading listing,
            report it through the platform for review.
          </p>
          <div className="legal-actions">
            <Link className="legal-btn" to="/market/browse">Browse listings</Link>
            <span className="legal-muted">Open a trade → Report</span>
          </div>
        </section>

        {/* LEGAL */}
        <section className="legal-card">
          <h2>Terms & Privacy</h2>
          <p>Rules for using the platform and how personal data is handled.</p>
          <div className="legal-actions">
            <Link className="legal-btn" to="/terms">Terms</Link>
            <Link className="legal-btn" to="/privacy">Privacy</Link>
          </div>
        </section>
      </div>
    </div>
  );
}
